import { Collection, ModelBase, ObservableCollection, Property, Required, VeryLongString } from '@skylab-shared/core';
import { InventoryDocumentKind } from './inventory-document-kind';
import { InventoryEffect } from './inventory-effect';
import { InventoryStocktakingDocumentItemModel } from './inventory-stocktaking-document-item.model';

export class InventoryStocktakingDocumentModel extends ModelBase {
    @Property({ identifiable: true })
    public id: number;

    @Property()
    @VeryLongString('data-model.inventory-document-model.validation.document-number.length')
    public documentNumber: string;

    @Property()
    public numberingId: number;

    @Property()
    public issueDate: Date;

    @Property()
    public readonly kind: InventoryDocumentKind = InventoryDocumentKind.Stocktaking;

    @Property()
    @Required('data-model.inventory-document-model.validation.inventory.required')
    public inventoryId: number;

    @Property()
    public preparer: string;

    @Property()
    public approver: string;

    @Collection({ type: InventoryStocktakingDocumentItemModel })
    public items: ObservableCollection<InventoryStocktakingDocumentItemModel>;

    @Property()
    public readonly inventoryEffect: InventoryEffect.Realized | InventoryEffect.Deferred;
}
